import React, {useCallback, useEffect, useRef} from "react";
import "./SourcesModal.css";

const SourcesModal = ({isOpen, onClose, sources}) => {
    const modalRef = useRef(null);

    const handleClickOutside = useCallback((event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    }, [onClose]);

    const handleKeyDown = useCallback((event) => {
        if (event.key === "Escape") {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleClickOutside, handleKeyDown]);


    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" ref={modalRef}>
                <h2>Fontes</h2>
                <button className="close-button" onClick={onClose}>×</button>
                <ul>
                    {Object.entries(
                        sources.reduce((acc, curr) => {
                            const title = curr.title || "Fonte sem título";
                            if (!acc[title]) {
                                acc[title] = [];
                            }

                            const pages = curr.documents?.flatMap(doc =>
                                Array.isArray(doc.pages) ? doc.pages : []
                            ) || [];

                            acc[title].push(...pages);
                            return acc;
                        }, {})
                    ).map(([title, pages], index) => (
                        <li key={index} className="source-item" style={{ marginBottom: "1.5rem" }}>
                            <strong style={{ fontSize: "1.2rem" }}>{title}</strong>
                            {pages.length > 0 && (
                                <div style={{ marginTop: "0.5rem" }}>
                                    Páginas: {Math.min(...pages)} a {Math.max(...pages)}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SourcesModal;
